export const DarkTheme = `DarkTheme`;
export const GridTheme = `GridTheme`;
export const SandTheme = `SandTheme`;
export const DarkBlue = `DarkBlue`;
export const Default = `Default`;
export const Gray = `Gray`;
export const DarkGreen = `DarkGreen`;
export const DarkUnica = `DarkUnica`;